<template>
  <!--  <img alt="Vue logo" src="./assets/logo.png">-->
  <!--  <HelloWorld />-->
  <router-view />
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
:root {
  --bg-primary: #050508;
  --bg-secondary: #0a0a12;
  --bg-card: rgba(8, 8, 18, 0.82);
  --border-subtle: rgba(255, 255, 255, 0.07);
  --border-accent: rgba(0, 240, 255, 0.4);
  --text-primary: #eef0ff;
  --text-secondary: #9898b8;
  --text-muted: #5c5c78;
  --neon-cyan: #00f0ff;
  --neon-purple: #bf00ff;
  --neon-pink: #ff006e;
  --neon-blue: #6366f1;
  --accent-start: #6366f1;
  --accent-end: #00f0ff;
  --accent-glow: rgba(0, 240, 255, 0.35);
  --purple-glow: rgba(191, 0, 255, 0.3);
  --danger: #ff4466;
  --radius-sm: 8px;
  --radius-md: 14px;
  --radius-lg: 20px;
  --transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background-color: var(--bg-primary);
  min-height: 100vh;
  min-width: 1200px;
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

body::before {
  content: '';
  position: fixed;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 55% at 15% 5%, rgba(191, 0, 255, 0.28), transparent 55%),
    radial-gradient(ellipse 70% 50% at 90% 90%, rgba(0, 240, 255, 0.2), transparent 50%),
    radial-gradient(ellipse 55% 45% at 50% 45%, rgba(99, 102, 241, 0.12), transparent 65%),
    radial-gradient(ellipse 40% 30% at 70% 20%, rgba(255, 0, 110, 0.1), transparent 60%);
  animation: auroraShift 14s ease-in-out infinite alternate;
  pointer-events: none;
  z-index: 0;
}

body::after {
  content: '';
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 240, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 240, 255, 0.04) 1px, transparent 1px);
  background-size: 50px 50px;
  mask-image: radial-gradient(ellipse 90% 80% at 50% 50%, black 15%, transparent 80%);
  -webkit-mask-image: radial-gradient(ellipse 90% 80% at 50% 50%, black 15%, transparent 80%);
  pointer-events: none;
  z-index: 0;
}

@keyframes auroraShift {
  0% { opacity: 0.8; transform: scale(1) rotate(0deg); }
  50% { opacity: 1; transform: scale(1.05) rotate(1deg); }
  100% { opacity: 0.9; transform: scale(1.02) rotate(-1deg); }
}

#app {
  min-height: 100vh;
  position: relative;
  z-index: 1;
}

/* ── Shared page FX ── */
.bg-fx {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  animation: orbFloat 8s ease-in-out infinite;
}

.orb-1 {
  width: 500px;
  height: 500px;
  background: rgba(191, 0, 255, 0.22);
  top: -12%;
  left: -8%;
  animation-delay: 0s;
}

.orb-2 {
  width: 420px;
  height: 420px;
  background: rgba(0, 240, 255, 0.18);
  bottom: -8%;
  right: -5%;
  animation-delay: -3s;
  animation-duration: 11s;
}

.orb-3 {
  width: 300px;
  height: 300px;
  background: rgba(255, 0, 110, 0.14);
  top: 35%;
  left: 50%;
  animation-delay: -5s;
  animation-duration: 13s;
}

.orb-4 {
  width: 200px;
  height: 200px;
  background: rgba(99, 102, 241, 0.2);
  top: 15%;
  right: 20%;
  animation-delay: -7s;
  animation-duration: 9s;
}

.stars {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(1px 1px at 10% 20%, rgba(255,255,255,0.5), transparent),
    radial-gradient(1px 1px at 30% 65%, rgba(255,255,255,0.4), transparent),
    radial-gradient(1.5px 1.5px at 55% 15%, rgba(0,240,255,0.6), transparent),
    radial-gradient(1px 1px at 70% 80%, rgba(255,255,255,0.35), transparent),
    radial-gradient(1px 1px at 85% 35%, rgba(255,255,255,0.45), transparent),
    radial-gradient(1.5px 1.5px at 20% 85%, rgba(191,0,255,0.5), transparent),
    radial-gradient(1px 1px at 45% 50%, rgba(255,255,255,0.3), transparent),
    radial-gradient(1px 1px at 92% 60%, rgba(0,240,255,0.4), transparent),
    radial-gradient(1px 1px at 5% 45%, rgba(255,255,255,0.35), transparent),
    radial-gradient(1px 1px at 60% 92%, rgba(255,255,255,0.4), transparent);
  animation: starTwinkle 6s ease-in-out infinite alternate;
}

@keyframes starTwinkle {
  from { opacity: 0.6; }
  to { opacity: 1; }
}

@keyframes orbFloat {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(30px, -20px) scale(1.08); }
  66% { transform: translate(-20px, 15px) scale(0.95); }
}

.scanline {
  position: fixed;
  inset: 0;
  background: repeating-linear-gradient(
    0deg,
    transparent,
    transparent 2px,
    rgba(0, 0, 0, 0.06) 2px,
    rgba(0, 0, 0, 0.06) 4px
  );
  pointer-events: none;
  z-index: 9999;
  opacity: 0.25;
}

/* ── Card shell (static, calm) ── */
.cyber-card {
  position: relative;
  isolation: isolate;
  border-radius: var(--radius-lg);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow:
    0 16px 48px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.cyber-card::before,
.cyber-card::after {
  display: none;
}

.card-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  border-color: rgba(255, 255, 255, 0.15);
  border-style: solid;
  opacity: 0.5;
  z-index: 2;
}

.card-corner.tl { top: 12px; left: 12px; border-width: 1px 0 0 1px; }
.card-corner.tr { top: 12px; right: 12px; border-width: 1px 1px 0 0; }
.card-corner.bl { bottom: 12px; left: 12px; border-width: 0 0 1px 1px; }
.card-corner.br { bottom: 12px; right: 12px; border-width: 0 1px 1px 0; }

.card-glow {
  display: none;
}

.card-inner {
  background: var(--bg-card);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: var(--radius-lg);
}

/* ── Title accent (background area only feel) ── */
.neon-text {
  font-family: 'Orbitron', 'DM Sans', sans-serif;
  background: linear-gradient(135deg, #c4b5fd 0%, #818cf8 50%, #67e8f9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: none;
}

/* ── Calm form controls ── */
.el-button--primary {
  --el-button-bg-color: #5b5fc7 !important;
  --el-button-border-color: #5b5fc7 !important;
  --el-button-hover-bg-color: #686bd0 !important;
  --el-button-hover-border-color: #686bd0 !important;
  --el-button-active-bg-color: #4f53b8 !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em;
  text-transform: none;
  font-size: 14px !important;
  border-radius: var(--radius-sm) !important;
  box-shadow: none !important;
  transition: background var(--transition), opacity var(--transition) !important;
}

.el-button--primary:hover {
  transform: none !important;
  opacity: 0.92;
}

.el-button--danger {
  --el-button-bg-color: rgba(255, 255, 255, 0.04) !important;
  --el-button-border-color: rgba(255, 255, 255, 0.12) !important;
  --el-button-text-color: #b0b0c0 !important;
  --el-button-hover-bg-color: rgba(255, 255, 255, 0.07) !important;
  --el-button-hover-border-color: rgba(255, 255, 255, 0.18) !important;
  --el-button-hover-text-color: #d0d0dc !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  border-radius: var(--radius-sm) !important;
  box-shadow: none !important;
}

.el-button--danger:hover {
  box-shadow: none !important;
}

.el-input__wrapper {
  background-color: rgba(255, 255, 255, 0.04) !important;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08) inset !important;
  border-radius: var(--radius-sm) !important;
  transition: box-shadow var(--transition) !important;
}

.el-input__wrapper:hover {
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.14) inset !important;
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.5) inset, 0 0 0 2px rgba(129, 140, 248, 0.12) !important;
}

.el-input__inner {
  color: var(--text-primary) !important;
}

.el-input-group__prepend {
  background: rgba(255, 255, 255, 0.04) !important;
  color: var(--text-secondary) !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0;
  text-transform: none;
}

.el-input.is-disabled .el-input__wrapper {
  background-color: rgba(255, 255, 255, 0.02) !important;
  opacity: 0.55;
}

.el-radio.is-bordered {
  background: rgba(255, 255, 255, 0.03) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: var(--radius-sm) !important;
  transition: border-color var(--transition), background var(--transition) !important;
}

.el-radio.is-bordered:hover {
  border-color: rgba(255, 255, 255, 0.18) !important;
  box-shadow: none !important;
}

.el-radio.is-bordered.is-checked {
  border-color: rgba(129, 140, 248, 0.5) !important;
  background: rgba(129, 140, 248, 0.08) !important;
  box-shadow: none !important;
}

.el-radio__input.is-checked + .el-radio__label {
  color: var(--text-primary) !important;
}

.el-drawer {
  background: rgba(8, 8, 14, 0.98) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: none !important;
}

.el-drawer__header {
  color: var(--text-primary) !important;
  font-family: inherit !important;
  font-size: 15px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 0 !important;
  padding-bottom: 16px !important;
}

.el-drawer__body {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px !important;
}

.el-select .el-input__wrapper {
  background-color: transparent !important;
}

/* Language select dropdown (teleported to body) */
.lang-dropdown.el-popper {
  background: rgba(12, 12, 20, 0.97) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: var(--radius-sm) !important;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.45) !important;
  backdrop-filter: blur(16px);
}

.lang-dropdown .el-select-dropdown {
  background: transparent !important;
  border: none !important;
}

.lang-dropdown .el-select-dropdown__list {
  padding: 4px !important;
}

.lang-dropdown .el-select-dropdown__item {
  color: var(--text-secondary) !important;
  background: transparent !important;
  border-radius: 6px;
  font-size: 13px;
  padding: 0 12px !important;
  height: 34px;
  line-height: 34px;
}

.lang-dropdown .el-select-dropdown__item.hover,
.lang-dropdown .el-select-dropdown__item.is-hovering {
  background: rgba(255, 255, 255, 0.06) !important;
  color: var(--text-primary) !important;
}

.lang-dropdown .el-select-dropdown__item.selected,
.lang-dropdown .el-select-dropdown__item.is-selected {
  color: #a5b4fc !important;
  background: rgba(129, 140, 248, 0.12) !important;
  font-weight: 500;
}

.lang-dropdown .el-popper__arrow::before {
  background: rgba(12, 12, 20, 0.97) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

.el-message {
  border-radius: var(--radius-sm) !important;
  backdrop-filter: blur(12px);
}
</style>
